import { FEATURES } from '/src/features/_global/constants';

export const TEAM_AND_SHARING_PERMISSIONS = {
  [FEATURES.TEAM]: ({ capabilities }) => ({
    navigate: capabilities?.teamSettings.permissions.nav,
    edit: capabilities?.teamSettings.permissions.edit,
  }),
  [FEATURES.SHARING]: ({ capabilities }) => ({
    navigate: capabilities?.sharing.permissions.nav,
    edit: capabilities?.sharing.permissions.edit,
  }),
};
